<template>
  <div>
    <header class="app-header" :class="IS_TEST_SETUP ? 'testSetup' : ''">
      <div class="col-3 col-md-8 col-lg-8 col-xl-8">
        <button class="btn-sidebar-toggler" @click="setMobileSidebar(!getMobileSidebar)" v-if="isMobile">
          <span></span>
          <span></span>
          <span></span>
        </button>
        <div class="app-search" :class="isMobile && 'ml-5'" @click="toggleSearch()"></div>
      </div>
      <div class="col-md-4 col-lg-4 col-xl-4 align-self-center pr-5">
        <div class="float-right d-flex align-items-center">
          <!-- Sem Version -->
          <div class="d-flex flex-column mr-1 text-center" style="line-height: 1; min-width: 117px" v-if="!isMobile">
            <span> Version </span>
            <span> {{ semver }} </span>
          </div>
          <div class="d-flex flex-column mr-3 text-center" style="line-height: 1; min-width: 100px"
            v-if="historicalDataLink && !IS_TEST_SETUP">
            <span class="font-weight-bold"> <a :href="historicalDataLink" class="text-blue text-center"
                target="_blank">Historical Data</a>
            </span>
            <!-- <span> {{ semver }} </span> -->
          </div>
          <!-- BACKEND RELEASE -->
          <!-- <div
            class="d-flex flex-column mr-3 text-center"
            style="line-height: 1; min-width: 117px;"
            v-if="!isMobile"
          >
            <span> Release </span>
            <span> {{ releaseVersion }} </span>
          </div> -->

          <!-- LANGUAGE DROPDOWN -->
          <div class="d-flex" v-if="!isMobile">
            <img src="@/assets/img/icons/language-icon.svg" height="25px" width="25px" />
            <b-dropdown right :text="selectedLanguage" variant="transparent text-muted" class="lang-btn p-0">
              <div v-for="(language, index) in languages" :key="index">
                <b-dropdown-item @click="changeLanguage(language)">{{
                  language.title
                }}</b-dropdown-item>
              </div>
            </b-dropdown>
          </div>

          <!-- NOTIFICATIONS -->
          <!-- <div class="header-notification" v-on-clickaway="away">
            <button
              class="btnj btn-notification px-4 mt-1"
              v-on:click="openNotificaton()"
            ></button>
            <div class="notification-count">{{ Notifications.length }}</div>
            <div
              class="header-notification-list-container"
              v-if="showNotification"
            >
              <div class="section-title pb-2 mb-3 border-bottom">
                Your Notifications
              </div>

              <ul
                v-if="Notifications.length > 0"
                class="header-notification-list"
              >
                <li
                  v-for="(notificationList,
                  notificationListIndex) in Notifications"
                  :key="notificationListIndex"
                >

                  <div class="notification-detail">
                    <p
                      class="mb-2"
                      @click.prevent.stop="UpdateNotification(notificationList)"
                    >
                      {{ notificationList.notification_msg }}
                    </p>
                    <div class="text-muted small">
                      {{ notificationList.created_at | timefornotification }}
                    </div>
                  </div>
                </li>
              </ul>
              <ul v-else class="header-notification-list">
                <li>
                  <div class="notification-detail">
                    <p class="mb-2">No Notification.</p>
                  </div>
                </li>
              </ul>
            </div>
          </div> -->

          <!-- ORG LOGO -->
          <div class="d-flex" v-if="!isMobile" :style="QfxClient ? 'background-color:#414042' : ''">
            <div class="" v-if="showOrgLogo">
              <img :src="getOrganizationDetails.org_logo_url" height="auto" :width="getOrganizationDetails.org_name == 'Empire Cinemas'
                ? '130'
                : '100'
                " class="mx-2" />
            </div>
          </div>
          <!-- ORG LOGO END -->
          <div class="d-flex" v-if="IS_TEST_SETUP">
            <div class="text-truncate fw-b">Demo Setup</div>
          </div>

          <!-- PROFILE / SETTINGS -->
          <div class="d-flex ml-2">
            <b-dropdown right variant="transparent">
              <template v-slot:button-content>
                <span style="font-size: 14px">{{ userInfo }}</span> &nbsp;
                <img width="28" height="28" v-if="imagePath" :src="BASEURL + imagePath" />
                <img v-else src="@/assets/img/icons/user-male.svg" height="28" width="28" />
                <!-- <img v-if="genderId==1 || genderId==null" src="@/assets/img/icons/user-male.svg" height="40" width="40" /> -->
                <!-- <img v-if="genderId==2" src="@/assets/img/icons/user-female.svg" height="40" width="40" /> -->
              </template>

              <b-dropdown-item href @click.native="goToRoute()">Profile</b-dropdown-item>
              <b-dropdown-item v-b-modal.changePassword>Change Password</b-dropdown-item>
              <b-dropdown-item v-b-modal.sendfeedback>Feedback</b-dropdown-item>
              <b-dropdown-item v-on:click="onLogout()" href>Logout</b-dropdown-item>
            </b-dropdown>
          </div>
        </div>
      </div>
    </header>

    <section class="section-global-search" v-if="globalSearch">
      <div class="search-wrapper">
        <div class="search-container">
          <input type="search" ref="typeBox" @keyup.down="nextItem($event)" @keyup.up="nextItem($event)"
            @keyup.enter="nextItem($event)" @keyup="onSearchComponents()"
            placeholder="Search Components, Movies, Distributors" v-model="searchText" autofocus />

          <div class="py-2 border-top border-muted" v-if="searchText.length > 0">
            <ul class="list-unstyled mb-0 px-2 spot-light-search">
              <!-- v-if="ChildNav.hasOwnProperty('permissions') && checkNavPermissions(ChildNav.permissions,ChildNav.cine_direct_sale)" -->
              <li v-if="ActiveSideNav && ActiveSideNav.length > 0" v-for="(ChildNav, _index) in ActiveSideNav"
                :key="_index">
                <router-link @click.native="toggleSearch()" :to="ChildNav.url"
                  :class="{ 'is-active': _index === arrowCounter }">{{ $tc(ChildNav.name, 2) }}
                  <span v-if="
                    ChildNav.hasOwnProperty('tagDescription') &&
                    ChildNav.tagDescription
                  " class="tagDescription-small-font">
                    {{ $tc(ChildNav.tagDescription) }}
                  </span>
                  <span class="router-small-font">
                    - {{ $tc(ChildNav.description) }}
                  </span></router-link>
              </li>
            </ul>
          </div>
        </div>
        <div class="close-backdrop" @click="toggleSearch()"></div>
      </div>
    </section>
    <b-modal id="sendfeedback" title="Send Feedback" hide-header hide-footer>
      <div class="col-12 text-center mb-4 pb-2 mt-3">
        <h4>Feedback</h4>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1">
        <div class="d-flex align-items-center">
          <div class="input-material">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <input id="subject" name="subject" v-validate="'required'" v-model="subject" placeholder="." />
            <label>Subject</label>
          </div>
          <!-- <Tooltip :title="$t('subject')" />-->
        </div>
        <p class="error_message">
          <span v-if="submitted2 && errors.has('subject')">{{
            errors.first("subject")
          }}</span>
        </p>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1">
        <div class="d-flex align-items-center">
          <div class="input-material-textarea">
            <!-- @focus="onFocusHandler" -->
            <!-- :required="item.required" -->
            <textarea id="description" name="description" v-validate="'required'" v-model="description"
              placeholder="." />
            <label :class="description.length > 0 ? 'shift-up' : ''">Description</label>
          </div>
          <!-- <Tooltip :title="$t('description')" />-->
        </div>
        <p class="error_message">
          <span v-if="submitted2 && errors.has('description')">{{
            errors.first("description")
          }}</span>
        </p>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1">
        <div class="d-flex align-items-center">
          <multiselect :options="priority_list" v-model="selected_priority" :searchable="true" label="name"
            track-by="name" placeholder="Select Priority" :allowEmpty="false" :showLabels="false"></multiselect>
        </div>
        <p class="error_message">
          <span v-if="submitted2 && !selected_priority">{{
            errors.first("description")
          }}</span>
        </p>
      </div>
      <div class="col-lg-12 col-xl-12 mb-1 text-center">
        <button @click.prevent.stop="sendFeedback" class="btn-blue">
          {{ $t("submit") }}
        </button>
        <button @click.prevent.stop="$bvModal.hide('sendfeedback')" class="btn-blue">
          Cancel
        </button>
      </div>
    </b-modal>

    <b-modal id="changePassword" :size="showcurrentpassword ? 'md' : 'lg'" title="Change Password" hide-header
      hide-footer>
      <form>
        <button @click.prevent.stop="OnCloseModal" class="btn-modal-close"
          style="position: absolute; right: 15px; top: 15px; z-index: 99">
          &times;
        </button>
        <div class="row mb-2 mx-0">
          <div class="col-12 text-center mb-4 pb-2 mt-3">
            <h4>Change Password</h4>
          </div>
          <!-- Current / Existing Password -->
          <div class="col-lg- mx-auto align-self-center" v-if="showcurrentpassword">
            <div class>
              <div class="mb-3">
                <div class="input-material">
                  <input type="password" v-model="password" name="currentpass" id="currentpass" v-validate="'required'"
                    placeholder="." />
                  <label>Current Password</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('currentpass')">{{
                    errors.first("currentpass")
                  }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button @click.prevent.stop="$bvModal.hide('changePassword')" class="btn-white-lg w-50 mr-2">
                  Cancel
                </button>
                <button @click.prevent.stop="ProceedtoNewPassword" class="btn-blue-lg w-50 ml-2">
                  Proceed
                </button>
              </div>
            </div>
          </div>

          <!-- New Password -->
          <div class="col-lg-5 border-right" v-if="shownewpassword">
            <ul class="list-unstyled">
              <li class="mb-2">
                <div class="text-muted font-weight-light" style="font-size: 16px">
                  Password must contain:
                </div>
              </li>
              <li class="mb-3">
                <b-form-checkbox disabled class="j-checkbox" v-model="changePasswordRequirements.atleast6char">
                  <div class="text-muted">Atleast 6 Character</div>
                </b-form-checkbox>
              </li>
              <li class="mb-3">
                <b-form-checkbox disabled class="j-checkbox" v-model="changePasswordRequirements.atleast1num">
                  <div class="text-muted">Atleast 1 Number (0-9)</div>
                </b-form-checkbox>
              </li>
              <li class="mb-3">
                <b-form-checkbox disabled class="j-checkbox" v-model="changePasswordRequirements.atleast1uppercase">
                  <div class="text-muted">Atleast 1 uppercase letter (A-Z)</div>
                </b-form-checkbox>
              </li>
              <li>
                <b-form-checkbox disabled class="j-checkbox" v-model="changePasswordRequirements.atleast1lowercase">
                  <div class="text-muted">Atleast 1 lowercase letter (a-z)</div>
                </b-form-checkbox>
              </li>
            </ul>
          </div>
          <div class="col-lg-7 pl-5 align-self-center" v-if="shownewpassword">
            <div>
              <div class="mb-3">
                <div class="input-material">
                  <input type="password" v-model="epassword" name="forgotpassword" id="forgotpassword"
                    ref="forgotpassword" v-validate="{
                      required: 'required',
                      regex:
                        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z0-9!@#$%^&*]{6,}$/,
                    }" placeholder="." autofocus />
                  <label>Enter Password</label>
                </div>
                <p class="error_msg">
                  <span v-if="submitted && errors.has('forgotpassword')" class="error_message">{{
                    errors.first("forgotpassword") }}</span>
                </p>
              </div>
              <div class="mb-3">
                <div class="input-material">
                  <input type="password" v-model="cpassword" name="forgotconfirm" id="forgotconfirm"
                    v-validate="'required|confirmed:forgotpassword'" placeholder="." autofocus />
                  <label>Confirm Password</label>
                </div>
                <p class="error_message">
                  <span v-if="submitted && errors.has('forgotconfirm')" class="error_message">{{
                    errors.first("forgotconfirm") }}</span>
                </p>
              </div>
              <div class="d-flex">
                <button @click.prevent.stop="$bvModal.hide('changePassword')" class="btn-white-lg w-50 mr-2">
                  Cancel
                </button>
                <button @click.prevent.stop="onFinalProceed" class="btn-blue-lg w-50 ml-2">
                  Proceed
                </button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </b-modal>

    <div id="v-idle" style="display: none">
      <!-- :duration in seconds-->
      <v-idle @idle="onIdleLogout" :events="['mousemove', 'keypress', 'ontouchstart', 'onclick']" :loop="true"
        :duration="60 * 60" />
    </div>
  </div>
</template>

<script>
import languages from "@/helper/Languages";
import i18n from "@/plugins/i18n";
import { BASEURL } from "@/config/index.js";
import UserService from "@/services/UserService";
import LogService from "@/services/LogService";
import FreshDesk from "@/services/FreshDeskService";
import { EventBus } from "@/main";
import { CLIENT_NAME } from "@/helper/Role";
import Nav from "@/Nav";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import { directive as onClickaway } from "vue-clickaway";

export default {
  directives: {
    onClickaway: onClickaway,
  },
  data() {
    return {
      submitted2: false,
      selected_priority: null,
      priority_list: [
        {
          name: "Low",
          id: 1,
        },
        {
          name: "Medium",
          id: 2,
        },
        {
          name: "High",
          id: 3,
        },
        {
          name: "Urgent",
          id: 4,
        },
      ],
      description: "",
      subject: "",
      globalSearch: false,
      searchText: "",
      changePasswordRequirements: {
        atleast6char: true,
        atleast1num: true,
        atleast1uppercase: true,
        atleast1lowercase: true,
      },
      showcurrentpassword: true,
      shownewpassword: false,
      password: "",
      epassword: "",
      cpassword: "",
      submitted: false,

      showNotification: false,
      languages,
      selectedLanguage: "English",
      URL_BASE: BASEURL,

      SideNav: [],
      AllSideNav: [],
      //
      arrowCounter: 0,
      showOrgLogo: true,
      AllModulelist: [],
    };
  },
  computed: {
    ...mapGetters([
      "getHeaderSearch",
      "getOrganizationDetails",
      "getHealthMeta",
      "getMobileSidebar",
      "getUserProfile",
    ]),
    QfxClient() {
      return CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME;
    },
    historicalDataLink() {
      const links = {
        empire: "",
        qfx: "https://archived-dashboard.qfxcinemas.com"
      }

      if (CLIENT_NAME.EMPIRE == this.CLIENT_SETUP_NAME) {
        return links.empire
      } else if (CLIENT_NAME.QFX == this.CLIENT_SETUP_NAME) {
        return links.qfx
      }

      return ""
    },
    ActiveSideNav() {
      this.SideNav = this.SideNav.map((x) => {
        if (x.hasOwnProperty("only_visible_on")) {
          if (this.CLIENT_SETUP_NAME) {
            let checkKeyExist = x.only_visible_on.filter((ovo) => {
              return ovo.key_name == this.CLIENT_SETUP_NAME;
            });

            if (checkKeyExist.length > 0) {
              x["show"] = true;
            } else {
              x["show"] = false;
            }
          } else {
            x["show"] = false;
          }
        } else {
          x["show"] = true;
        }

        return x;
      });
      let filteredMenu = this.SideNav;
      let AllActiveSideMenu = this.AllModulelist.filter(
        (x) => x.module_is_active == "Y"
      );

      // console.log({
      //   SideNav: Array.from(this.SideNav),
      //   AllModulelist: Array.from(this.AllModulelist),
      //   filteredMenu: this.SideNav.filter((x) =>
      //     AllActiveSideMenu.some((y) => y.module_id == x.module_id && x.show)
      //   ),
      // });

      filteredMenu = this.SideNav.filter((x) =>
        AllActiveSideMenu.some((y) => y.module_id == x.module_id && x.show)
      );
      return filteredMenu;
    },
    IS_TEST_SETUP() {
      return this.$store.getters.isTestSetup;
    },
    isMobile() {
      return this.$store.getters.getIsMobile;
    },
    semver() {
      return "V 1.0.0";
    },
    releaseVersion() {
      return "03-Jan-22-18:00";
      // let committedOn = this.getHealthMeta.git.committedOn || "";
      //
      // let readableDate = moment(committedOn);
      // let readableDateWithOffset = moment(committedOn * 1000);
      //
      // return readableDate.isValid()
      //   ? readableDate.format("DD-MMM-YY-HH:mm")
      //   : readableDateWithOffset.isValid()
      //   ? readableDateWithOffset.format("DD-MMM-YY-HH:mm")
      //   : "v1.0";
    },
    userInfo() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").first_name &&
        this.secureStore.get("USINFO").last_name
        ? this.secureStore.get("USINFO").first_name +
        " " +
        this.secureStore.get("USINFO").last_name
        : "Admin";
    },
    userId() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").user_id
        ? this.secureStore.get("USINFO").user_id
        : null;
    },
    genderId() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").gender_id
        ? this.secureStore.get("USINFO").gender_id
        : null;
    },
    imagePath() {
      return this.secureStore.get("USINFO") &&
        this.secureStore.get("USINFO").user_profile_image_url
        ? this.secureStore.get("USINFO").user_profile_image_url
        : null;
    },
    Notifications() {
      if (
        this.$store.getters.NotificationList &&
        this.$store.getters.NotificationList.length > 0
      ) {
        let list = this.$store.getters.NotificationList.filter(
          (x) => x.user_id == this.userId
        );
        return list;
      } else {
        return [];
      }
    },
  },
  beforeMount() {
    this.checkUserLoggedInFunction();
    this.checkUserType();
    this.GetNotifications();
    this.getAllModuleList();
  },
  mounted() {
    let activeModules = this.secureStore.get("module_list");

    let user_role_id =
      this.secureStore.get("USINFO") && this.secureStore.get("USINFO").role_id
        ? this.secureStore.get("USINFO").role_id
        : null;
    let user_roles_array = [1, 2, 3, 4, 8, 9, 10, 11, 12];
    if (user_roles_array.indexOf(user_role_id) > -1) {
      this.getAllChildren(Nav.items, false, null);
    } else if (
      user_roles_array.indexOf(user_role_id) == -1 &&
      activeModules &&
      activeModules.length > 0
    ) {
      this.getAllChildren(Nav.items, true, activeModules);
    }
  },
  methods: {
    away: function () {
      this.showNotification = false;
    },
    getAllModuleList: function () {
      UserService.ModulesList()
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.AllModulelist = data.Records;
          } else {
            this.AllModulelist = [];
          }
        })
        .catch((err) => {
          console.log("ERROR", err);
        });
    },
    ...mapActions(["setHeaderSearch", "setMobileSidebar"]),
    getAllChildren: function (
      parent,
      withActiveModules = false,
      activeModules
    ) {
      if (parent && parent.length > 0) {
        for (let module of parent) {
          if (!module.children && module.module_id) {
            if (withActiveModules && activeModules) {
              if (activeModules.some((am) => String(am) == module.module_id)) {
                this.SideNav.push(module);
                this.AllSideNav.push(module);
              }
            } else {
              this.SideNav.push(module);
              this.AllSideNav.push(module);
            }
          } else if (module.children && module.children.length > 0) {
            this.getAllChildren(
              module.children,
              withActiveModules,
              activeModules
            );
          }
        }
      }
    },
    nextItem(event) {
      if (event.keyCode == 38 && this.arrowCounter >= 0) {
        this.arrowCounter--;
      } else if (
        event.keyCode == 40 &&
        this.arrowCounter < this.SideNav.length - 1
      ) {
        this.arrowCounter++;
      } else if (
        event.keyCode == 13 &&
        this.arrowCounter >= 0 &&
        this.SideNav.length != 0
      ) {
        let path = this.SideNav[this.arrowCounter].url;
        if (path && String(path).length > 0) {
          this.globalSearch = false;
          this.$router
            .push({
              path: path,
            })
            .catch((err) => {
              if (err && err.message) {
                this.$toasted.show(err.message);
              } else {
                this.$toasted.show("Something went wrong.");
              }
            });
        }
      }
    },
    checkUserType() {
      let userInfo = this.secureStore.get("USINFO");
      if (
        (userInfo && userInfo.role_id == 8) ||
        (userInfo && userInfo.role_id == 4)
      ) {
        this.$toasted.show(
          "Sorry, as a POS user you do not have access to the dashboard"
        );
        this.onLogout();
      }
    },

    checkUserLoggedInFunction() {
      UserService.checkUserLoggedIn({}).then((response) => {
        const { data } = response;

        if (data.status && data.errorCode == 200) {
        } else if (data.errorCode == 409) {
          this.onLogout();
        }
      });
    },
    sendFeedback() {
      this.submitted2 = true;
      this.$validator.validate().then((valid) => {
        console.log(
          "valid && this.selected_priority :>> ",
          valid && this.selected_priority
        );
        if (valid && this.selected_priority) {
          let payload = {
            subject: this.subject,
            description: this.description,
            priority_id: this.selected_priority.id,
          };
          FreshDesk.SendFeedback(payload)
            .then((response) => {
              const { data } = response;
              if (data && data.status) {
                this.$toasted.show("Feedback submitted successfully");
                this.$bvModal.hide("sendfeedback");
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch((error) => {
              this.$toasted.show(error);
            });
        }
      });
    },
    GetNotifications: function () {
      this.$store.dispatch("GetNotifications", {
        user_id: this.userId,
        limit: 10,
        currentPage: 1,
      });

      //For Insert Notification
      // this.$store.dispatch("SendNotificationLog", {
      //   title: "User Logged In Notification",
      //   message: `${finalObj.user_id} Just Logged In Pos-Login`,
      //   type: "Login",
      //   user_id: finalObj.user_id,
      //   isRead: "Y"
      // });
    },
    UpdateNotification: function (data) {
      this.$store.dispatch("UpdateNotification", {
        notification_id: data.nl_id,
        user_id: data.user_id,
      });
    },
    toggleSearch: function () {
      this.globalSearch = !this.globalSearch;
      EventBus.$emit("changeInStatusSearch");

      this.$nextTick(() => this.$refs.typeBox && this.$refs.typeBox.focus());
      this.setHeaderSearch(!this.getHeaderSearch);
      this.searchText = "";
      // this.$refs.search.focus()
    },
    OnCloseModal() {
      this.$bvModal.hide("changePassword");
      this.shownewpassword = false;
      this.showcurrentpassword = true;
      this.password = "";
    },
    onSearchComponents: function () {
      this.SideNav = this.AllSideNav;
      let ModulesAvailable = this.getUserProfile.user_modules;
      let ActiveUserModule = ModulesAvailable;
      const filteredArray1 = this.ActiveSideNav.filter((obj1) =>
        ActiveUserModule.some((obj2) => obj2["module_id"] === obj1["module_id"])
      );
      // console.log(filteredArray1, "filteredArray1");
      // console.log(ActiveUserModule, "ActiveUserModule");
      if (this.searchText.length > 0) {
        let searchTextTerms = this.searchText
          .split(" ")
          .filter((x) => x)
          .map((s) => s.toLowerCase());

        let filterByName = filteredArray1.filter((x) => {
          if (x.name) {
            for (let term of x.name.toLowerCase().split(" ")) {
              if (searchTextTerms.some((x) => term.includes(x))) return x;
            }
          }
        });
        let filterByDesc = filteredArray1.filter((x) => {
          let desc = this.$t(x.description);
          if (desc) {
            for (let term of desc.toLowerCase().split(" ")) {
              if (searchTextTerms.some((x) => term.includes(x))) return x;
            }
          }
        });
        let filterByKeyWords = filteredArray1.filter((x) => {
          if (x.keywords && x.keywords.length > 0) {
            for (let keyword of x.keywords) {
              if (
                keyword
                  .toLowerCase()
                  .split(" ")
                  .some((term) => searchTextTerms.some((x) => term.includes(x)))
              ) {
                return x;
              }
            }
          }
        });

        this.SideNav = Array.from(
          new Set([...filterByName, ...filterByDesc, ...filterByKeyWords])
        );

        // console.log(this.ActiveSideNav, "this.ActiveSideNav");
        // console.log(filterByName, "filterByName");
        // console.log(this.SideNav, "this.SideNav");
      } else {
        this.SideNav = this.AllSideNav;
      }
    },
    checkNavPermissions: function (permissions, direct_sale_flag) {
      if (!this.secureStore.get("USINFO")) return false;
      else {
        if (direct_sale_flag) {
          const { cine_direct_sale } = this.secureStore.get("USINFO");
          if (cine_direct_sale == "Y") {
            return false;
          }
        }

        const { role_name } = this.secureStore.get("USINFO");
        return permissions && permissions.length > 0
          ? permissions.filter((role) => role.trim() === role_name.trim())
            .length > 0
          : true;
      }
    },
    ProceedtoNewPassword() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            userid: this.userId,
            userpassword: this.password,
          };
          UserService.VerifyCurrentPassword(payload).then((response) => {
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.showcurrentpassword = false;
              this.shownewpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },

    onFinalProceed() {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let payload = {
            userid: this.userId,
            password: this.cpassword,
          };

          UserService.UpdateChangePassword(payload).then((response) => {
            const { data } = response;

            if (data.status) {
              this.$toasted.show(data.message);
              this.$bvModal.hide("changePassword");
              this.epassword = "";
              this.cpassword = "";
              this.showcurrentpassword = true;
            } else {
              this.$toasted.show(
                data.message ||
                "Sorry! Something went wrong. kindly contact your administrator"
              );
            }
          });
        }
      });
    },

    goToRoute() {
      this.$router.push({
        path: "/user-management/view-user?user_id=" + this.userId + "",
      });
    },
    openNotificaton: function () {
      this.showNotification = !this.showNotification;
    },
    /* eslint-disable */
    changeLanguage: function ({ language, title }) {
      i18n.locale = language;
      this.selectedLanguage = title;
    },
    onLogout: function () {
      localStorage.removeItem("ModulesAvailable");
      UserService.removeToken()
        .then((res) => {
          const { data } = res;
          if (data.status === false) this.$toasted.show(data.message);

          window.localStorage.removeItem("JWT_TOKEN");
          window.localStorage.clear();
          this.$router.push({ path: "/login" });
          this.$cookie.delete("BRHSID");

          return window.caches.keys();
        })
        .then((caches) => {
          return Promise.all(caches.map((c) => window.caches.delete(c)));
        })
        .catch((err) => {
          if (this.$route.name !== "/login") {
            this.$router.push({ path: "/login" });
            this.$toasted.show("Token not removed");
          }
        });
    },
    onIdleLogout() {
      // alert('You have been logged out');
      this.onLogout();
    },
  },
};
</script>

<style>
.router-small-font {
  font-size: 11px;
  font-style: italic;
  color: #434345;
}

.tagDescription-small-font {
  font-size: 13px;
  font-style: italic;
  color: #434345;
}

.search-container a:hover .tagDescription-small-font {
  color: #fff;
}

.search-container a:active .tagDescription-small-font,
.search-container a.is-active .tagDescription-small-font {
  color: #fff;
}

.testSetup {
  border: 4px solid red;
  border-radius: 15px 0 0 0;
}

.fw-b {
  font-weight: bolder;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/components/Partials/header.vue